export const MIN_SEARCH_LENGT = 3;
export const SEARCH_VALID_REGEXP = /^[a-zA-Z0-9]+$/;
export const SEARCH_COORDINATES_REGEXP = /^-{0,1}[\d]{1,2}(\.\d){0,1}(\d?)*,{0,1}\s+-{0,1}[\d]{1,3}(\.\d){0,1}(\d?)*$/;
